import { render, staticRenderFns } from "./AppInstallDialog.vue?vue&type=template&id=194c4bf4"
import script from "./AppInstallDialog.vue?vue&type=script&lang=js"
export * from "./AppInstallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports